import React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Rating from '@mui/material/Rating';

import AttachMoneyIcon from '@mui/icons-material/AttachMoney';

import Typography from "@mui/material/Typography";
import { generateRandomNumber } from "../../../utils";
import { summarizeRating } from "../../../utils/reviews";


const StyledRating = styled(Rating)(({ theme }) => ({
  '& .MuiRating-iconEmpty .MuiSvgIcon-root': {
    color: theme.palette.action.disabled,
  },
}));

const customIcons = {
  1: {
    icon: <AttachMoneyIcon color="success" />,
    label: 'Bargain',
  },
  2: {
    icon: <AttachMoneyIcon color="success" />,
    label: 'Affordable',
  },
  3: {
    icon: <AttachMoneyIcon color="success" />,
    label: 'Pricy',
  },
  4: {
    icon: <AttachMoneyIcon color="success" />,
    label: 'Satisfied',
  },
  5: {
    icon: <AttachMoneyIcon color="success" />,
    label: 'Very Satisfied',
  },
};

function IconContainer(props) {
  const { value, ...other } = props;
  return <span {...other}>{customIcons[value].icon}</span>;
}

export function DollarRating() {
  return (
    <StyledRating
        name="cost-rating"
        value={generateRandomNumber(5)}
        IconContainerComponent={IconContainer}
        getLabelText={(value) => customIcons[value].label}
        size="large"
    />
  )
}

/**
 * A listing's rating, as travellers actually left it.
 *
 * This used to render `generateRandomNumber(5)` — a different score on every
 * render, for every listing, signifying nothing.
 *
 * With no reviews it says so rather than showing a confident 0.0, which reads
 * as a terrible listing rather than a new one. `summarizeRating` returns null
 * for exactly that case.
 */
export function StarRating({ listing, size = 'large' }) {
    const summary = summarizeRating(listing);

    if (!summary) {
        return (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                <Rating name="read-only" value={0} readOnly size={size} />
                <Typography variant="body2" color="text.secondary">
                    No reviews yet
                </Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
            <Rating
                name="read-only"
                value={summary.average}
                precision={0.1}
                readOnly
                size={size}
            />
            <Typography variant="body2" color="text.secondary">
                {summary.average.toFixed(1)} ({summary.count}{' '}
                {summary.count === 1 ? 'review' : 'reviews'})
            </Typography>
        </Box>
    );
}